import { Map as ImmutableMap, Record } from 'immutable';
import TrackingEvents from 'automation-ui-usage-tracking/TrackingEvents';
const TrackablesDictionary = {
  ACTION_TYPE_COUNT: {
    eventProps: {
      action: 'turned workflow on with action types'
    },
    eventType: TrackingEvents.ACTION_TYPE_COUNT_ON_ENABLE
  },
  ACTIVATED_WORKFLOW: {
    eventProps: {
      action: 'turned workflow on'
    },
    eventType: TrackingEvents.ACTIVATE_WORKFLOW
  },
  ADD_ACTION_CONFIG: {
    eventProps: {
      action: 'clicked to add action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ADD_DEAL_PROPERTY: {
    eventProps: {
      action: 'clicked to add deal property to deal action'
    },
    eventType: TrackingEvents.ADD_PROPERTY
  },
  ADD_RECOMMENDED_ACTION_CLICKED: {
    eventProps: {
      action: 'clicked to add recommended action'
    },
    eventType: TrackingEvents.ADD_RECOMMENDED_ACTION_CLICKED
  },
  DISMISS_RECOMMENDED_ACTION_CLICKED: {
    eventProps: {
      action: 'clicked to dismiss recommended action'
    },
    eventType: TrackingEvents.DISMISS_RECOMMENDED_ACTION_CLICKED
  },
  ADD_RECOMMENDED_ACTION_SHOWN: {
    eventProps: {
      action: 'view recommended action'
    },
    eventType: TrackingEvents.ADD_RECOMMENDED_ACTION_SHOWN
  },
  ADD_TICKET_PROPERTY: {
    eventProps: {
      action: 'clicked to add ticket property to ticket action'
    },
    eventType: TrackingEvents.ADD_PROPERTY
  },
  AGGREGATE_PERFORMANCE_CLICK_ACTION_CARD: {
    eventProps: {
      action: 'clicked action card on the metrics page workflow'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_CLICK_ACTION_CARD
  },
  AGGREGATE_PERFORMANCE_CLICK_MATCHING_ENROLLMENTS: {
    eventProps: {
      action: 'clicked matching enrollments button on the metrics panel.'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_CLICK_MATCHING_ENROLLMENTS
  },
  AGGREGATE_PERFORMANCE_CLOSE_MODE_INDICATOR: {
    eventProps: {
      action: 'clicked close icon on aggregate performance mode indicator'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_CLOSE_MODE_INDICATOR
  },
  AGGREGATE_PERFORMANCE_CONVERSION_METRICS_SECTION_TOGGLE: {
    eventProps: {
      action: 'clicked conversion metrics expandable section'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_EXPAND_COLLAPSE
  },
  AGGREGATE_PERFORMANCE_RESET_FILTERS: {
    eventProps: {
      action: 'clicked reset filters on the metrics panel.'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_RESET_FILTERS
  },
  AGGREGATE_PERFORMANCE_SUMMARY_SECTION_TOGGLE: {
    eventProps: {
      action: 'clicked summary expandable section'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_EXPAND_COLLAPSE
  },
  AGGREGATE_PERFORMANCE_TURN_ON_REPORTING: {
    eventProps: {
      action: 'clicked the toggle to turn on reporting'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_CLICK_TRACKING_TOGGLE
  },
  AGGREGATE_PERFORMANCE_VIEW_ENROLLMENT_HISTORY: {
    eventProps: {
      action: 'clicked view enrollment history on the metrics panel.'
    },
    eventType: TrackingEvents.AGGREGATE_PERFORMANCE_VIEW_ENROLLMENT_HISTORY
  },
  ANALYZE_FILTERS_COMPARE_TIME_RANGE: {
    eventProps: {
      action: 'changed comparison time window'
    },
    eventType: TrackingEvents.CHANGE_ANALYZE_TAB_FILTERS
  },
  ANALYZE_FILTERS_COMPARE_TYPE: {
    eventProps: {
      action: 'changed comparison type'
    },
    eventType: TrackingEvents.CHANGE_ANALYZE_TAB_FILTERS
  },
  ANALYZE_FILTERS_DATE_RANGE: {
    eventProps: {
      action: 'changed date range'
    },
    eventType: TrackingEvents.CHANGE_ANALYZE_TAB_FILTERS
  },
  ANALYZE_FILTERS_VIEWS: {
    eventProps: {
      action: 'selected views'
    },
    eventType: TrackingEvents.CHANGE_ANALYZE_TAB_FILTERS
  },
  ANALYZE_FILTERS_WORKFLOWS: {
    eventProps: {
      action: 'selected workflows'
    },
    eventType: TrackingEvents.CHANGE_ANALYZE_TAB_FILTERS
  },
  ASSIGN_TEAM_CLICK: {
    eventProps: {
      action: 'clicked to attempt to assign a workflow to a team'
    },
    eventType: TrackingEvents.ASSIGN_TEAM_CLICK
  },
  ASSIGNED_TEAM: {
    eventProps: {
      action: 'assigned a workflow to a team'
    },
    eventType: TrackingEvents.ASSIGNED_TEAM
  },
  BULK_ASSIGN_BUSINESS_UNIT_CLICK: {
    eventProps: {
      action: 'bulk assign business unit click'
    },
    eventType: TrackingEvents.BULK_ASSIGN_BUSINESS_UNIT_CLICK
  },
  BULK_ASSIGN_TEAM_CLICK: {
    eventProps: {
      action: 'clicked to bulk assign workflows'
    },
    eventType: TrackingEvents.BULK_ASSIGN_TEAM_CLICK
  },
  BULK_ASSIGNED_TEAM: {
    eventProps: {
      action: 'bulk assign workflows'
    },
    eventType: TrackingEvents.BULK_ASSIGN_TEAM
  },
  BULK_DELETE: {
    eventProps: {
      action: 'bulk delete workflows'
    },
    eventType: TrackingEvents.BULK_DELETE
  },
  BULK_DELETE_CLICK: {
    eventProps: {
      action: 'clicked to bulk delete workflows'
    },
    eventType: TrackingEvents.BULK_DELETE_CLICK
  },
  BULK_MOVE_WORKFLOW: {
    eventProps: {
      action: 'bulk moved one or more workflows'
    },
    eventType: TrackingEvents.BULK_MOVE_WORKFLOW
  },
  BULK_MOVE_WORKFLOW_CLICK: {
    eventProps: {
      action: 'clicked to attempt to bulk move one or more workflows'
    },
    eventType: TrackingEvents.BULK_MOVE_WORKFLOW_CLICK
  },
  CANCEL_IGNORE_ALL_RISKS: {
    eventProps: {
      action: 'clicked to cancel ignoring all risks for a workflow'
    },
    eventType: TrackingEvents.CANCEL_IGNORE_ALL_RISKS
  },
  CHANGE_BRANCH_OVERRIDE: {
    eventProps: {
      action: 'Changed branch override'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CHANGE_DETAILS_TAB: {
    eventProps: {
      action: 'changed details page tab'
    },
    eventType: TrackingEvents.CHANGE_DETAILS_TAB
  },
  CHANGE_INDEX_TAB: {
    eventProps: {
      action: 'changed index tab'
    },
    eventType: TrackingEvents.CHANGE_INDEX_TAB
  },
  CHANGED_ACTION_DATA_SOURCE: {
    eventProps: {
      action: 'changed selected data source for action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CHANGED_INDEX_FILTER: {
    eventProps: {
      action: 'changed workflow filters'
    },
    eventType: TrackingEvents.MANAGE_WORKFLOWS
  },
  CLEAR_MISSING_DEAL_ACTION_PROPS: {
    eventProps: {
      action: 'clicked to remove all missing deal action properties'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLEARED_TABLE_FILTERS: {
    eventProps: {
      action: 'cleared workflow filters'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  CLICK_ACCEPT_DELAY_UNTIL_DATE_ACTION_PROPERTY: {
    eventProps: {
      action: 'clicked to accept using a delay until date action instead of a property-based date'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_ACCEPT_DELAY_UNTIL_DATE_ACTION_STATIC: {
    eventProps: {
      action: 'clicked to accept using a delay until date action instead of a static date'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_ACTIONS_TAB: {
    eventProps: {
      action: 'clicked actions tab'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_ACTIVATE_WORKFLOW: {
    eventProps: {
      action: 'clicked to turn workflow on'
    },
    eventType: TrackingEvents.ACTIVATE_WORKFLOW
  },
  CLICK_ACTIVATE_WORKFLOW_FROM_EMBED: {
    eventProps: {
      action: 'clicked to turn workflow on from embed'
    },
    eventType: TrackingEvents.CLICKED_ACTIVATE_WORKFLOW_FROM_EMBED
  },
  CLICK_ACTIVATE_WORKFLOW_REVIEW_EXPERIMENT: {
    eventProps: {
      action: 'clicked to turn workflow on from the Review v2 Experiment'
    },
    eventType: TrackingEvents.ACTIVATE_WORKFLOW
  },
  CLICK_ALERTS: {
    eventProps: {
      action: 'clicked to expand/collaspse alerts'
    },
    eventType: TrackingEvents.CLICK_ALERTS
  },
  CLICK_CANCEL_RISK_SETINGS: {
    eventProps: {
      action: 'clicked Cancel on the settings section of the risk-details panel'
    },
    eventType: TrackingEvents.CLICK_CANCEL_RISK_SETINGS
  },
  CLICK_CHANGES_TAB: {
    eventProps: {
      action: 'clicked changes tab'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_CLOSE_RISK_DETAILS_PANEL: {
    eventProps: {
      action: 'clicked to close the risk details panel'
    },
    eventType: TrackingEvents.CLICK_CLOSE_RISK_DETAILS_PANEL
  },
  CLICK_CREATE_NEW_PROPERTY_LINK: {
    eventProps: {
      action: 'clicked link to create a new object property'
    },
    eventType: TrackingEvents.CLICK_CREATE_NEW_PROPERTY_LINK
  },
  CLICK_DATA_PANEL_PROPERTY_INFO: {
    eventProps: {
      action: 'clicked data panel property info icon'
    },
    eventType: TrackingEvents.CLICK_DATA_PANEL_PROPERTY_INFO
  },
  CLICK_DATA_PASSING_PANEL_COLLAPSE: {
    eventProps: {
      action: 'clicked to collapse data panel'
    },
    eventType: TrackingEvents.CLICK_DATA_PASSING_PANEL_COLLAPSE
  },
  CLICK_DATA_PASSING_PANEL_DATA_SOURCE: {
    eventProps: {
      action: 'clicked to select data source'
    },
    eventType: TrackingEvents.CLICK_DATA_PASSING_PANEL_DATA_SOURCE
  },
  CLICK_DEACTIVATE_WORKFLOW: {
    eventProps: {
      action: 'clicked to turn workflow off'
    },
    eventType: TrackingEvents.ACTIVATE_WORKFLOW
  },
  CLICK_DECLINE_DELAY_UNTIL_DATE_ACTION_PROPERTY: {
    eventProps: {
      action: 'clicked to decline using a delay until date action instead of a property-based date'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_DECLINE_DELAY_UNTIL_DATE_ACTION_STATIC: {
    eventProps: {
      action: 'clicked to decline using a delay until date action instead of a static date'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_DESCRIPTION: {
    eventProps: {
      action: 'clicked to edit description'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLICK_DETAILS_TOOLBAR: {
    eventProps: {
      action: 'clicked details in the toolbar'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_EDIT_COLUMNS: {
    eventProps: {
      action: 'clicked to edit table columns'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_EDIT_WORKFLOW_NAME_AND_DESCRIPTION: {
    eventProps: {
      action: 'opened edit workflow name and description modal'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLICK_EMAIL_FIELD_NEW_EMAIL_LINK: {
    eventProps: {
      action: 'generic config field interaction',
      subaction: 'clicked create new email external link'
    },
    eventType: TrackingEvents.CLICKED_EMAIL_FIELD_NEW_EMAIL_LINK
  },
  CLICK_EMBEDDED_COLLAPSED_CARD: {
    eventProps: {
      action: 'clicked to navigate to a Workflow edit page from an embedded collapsed Workflow card'
    },
    eventType: TrackingEvents.EVALUATE_PERFORMANCE
  },
  CLICK_FLOW_DETAILS_BUTTON: {
    eventProps: {
      action: 'clicked to view flow details'
    },
    eventType: TrackingEvents.CLICK_FLOW_DETAILS_BUTTON
  },
  CLICK_GENERATE_TEXT_FOR_INPUT: {
    eventProps: {
      action: 'clicked generate text button for input'
    },
    eventType: TrackingEvents.CLICK_GENERATE_TEXT_FOR_INPUT
  },
  CLICK_GENERATE_TEXT_FOR_INPUT_PROMPT: {
    eventProps: {
      action: 'clicked a prompt in generate text button for input'
    },
    eventType: TrackingEvents.CLICK_GENERATE_TEXT_FOR_INPUT_PROMPT
  },
  CLICK_GOALS: {
    eventProps: {
      action: 'clicked to edit goals'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLICK_GOALS_TAB: {
    eventProps: {
      action: 'clicked goals tab'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_GOALS_TOOLBAR: {
    eventProps: {
      action: 'clicked to edit goals in the toolbar'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLICK_MANUALLY_ENROLL: {
    eventProps: {
      action: 'clicked to manually enroll contacts'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  CLICK_MISMATCHED_VALUES_SUBPAGE: {
    eventProps: {
      action: "clicked 'view details' tooltip link for copying properties with mismatched values"
    },
    eventType: TrackingEvents.CLICK_MISMATCHED_VALUES_SUBPAGE
  },
  CLICK_NOTIFICATIONS_AND_SETTINGS: {
    eventProps: {
      action: 'clicked to go to notification settings'
    },
    eventType: TrackingEvents.CLICK_NOTIFICATIONS_AND_SETTINGS
  },
  CLICK_OPEN_RISK_DETAILS_PANEL: {
    eventProps: {
      action: 'clicked to open the risk details panel'
    },
    eventType: TrackingEvents.CLICK_OPEN_RISK_DETAILS_PANEL
  },
  CLICK_OPTIMIZATION_TOOLBAR: {
    eventProps: {
      action: 'clicked to clean up workflow in the toolbar'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CLICK_REGENERATE_TEXT_FOR_INPUT: {
    eventProps: {
      action: 'clicked regenerate text button for input'
    },
    eventType: TrackingEvents.CLICK_REGENERATE_TEXT_FOR_INPUT
  },
  CLICK_REVIEW_EDIT: {
    eventProps: {
      action: 'clicked on Edit button in Review page'
    },
    eventType: TrackingEvents.CLICK_REVIEW_EDIT
  },
  CLICK_REVIEW_WORKFLOW: {
    eventProps: {
      action: 'clicked to review workflow'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_SAVE_RISK_SETTINGS: {
    eventProps: {
      action: 'clicked Save on the settings section of the risk-details panel'
    },
    eventType: TrackingEvents.CLICK_SAVE_RISK_SETTINGS
  },
  CLICK_SECRETS_MANAGEMENT: {
    eventProps: {
      action: 'clicked to manage secrets'
    },
    eventType: TrackingEvents.CLICK_SECRETS_MANAGEMENT
  },
  CLICK_SETTINGS_TAB: {
    eventProps: {
      action: 'clicked settings tab'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_TEST_FLOW: {
    eventProps: {
      action: 'clicked to test flow'
    },
    eventType: TrackingEvents.CLICK_TEST_FLOW
  },
  CLICK_TEST_FLOW_RECORD: {
    eventProps: {
      action: 'clicked to test a specific record'
    },
    eventType: TrackingEvents.INTERACTION
  },
  CLICK_TEST_WORKFLOW: {
    eventProps: {
      action: 'clicked to test workflow'
    },
    eventType: TrackingEvents.TEST_WORKFLOW
  },
  CLICK_TO_ADD_FILTER_TO_PROMPT: {
    eventProps: {
      action: 'clicked to add a filter to an AI filter prompt'
    },
    eventType: TrackingEvents.CLICK_TO_ADD_FILTER_TO_PROMPT
  },
  CLICK_TO_GENERATE_ASSET: {
    eventProps: {
      action: 'clicked to generate asset'
    },
    eventType: TrackingEvents.CLICK_TO_GENERATE_ASSET
  },
  CLICK_TO_REMOVE_FILTER_FROM_PROMPT: {
    eventProps: {
      action: 'clicked to remove a filter from an AI filter prompt'
    },
    eventType: TrackingEvents.CLICK_TO_REMOVE_FILTER_FROM_PROMPT
  },
  CLICK_TOGGLE_MINIMAP: {
    eventProps: {
      action: 'clicked to toggle showing the workflows canvas minimap'
    },
    eventType: TrackingEvents.CLICK_TOGGLE_MINIMAP
  },
  CLICK_VIEW_ENROLLMENTS: {
    eventProps: {
      action: 'clicked to view enrollment history panel'
    },
    eventType: TrackingEvents.CLICK_VIEW_ENROLLMENTS
  },
  CLICK_VIEW_LOG: {
    eventProps: {
      action: 'clicked to view flow action logs'
    },
    eventType: TrackingEvents.CLICK_VIEW_LOG
  },
  CLICK_VIEW_NEW_ENROLLMENTS: {
    eventProps: {
      action: 'clicked to show new enrollment events'
    },
    eventType: TrackingEvents.CLICK_VIEW_NEW_ENROLLMENTS
  },
  CLICK_VIEW_RISKS: {
    eventProps: {
      action: 'clicked to view risks for flow'
    },
    eventType: TrackingEvents.CLICK_VIEW_RISKS
  },
  CLICKED_ACTION_CARD_OPTION: {
    eventProps: {
      action: 'clicked "Actions" menu option in Canvas'
    },
    eventType: TrackingEvents.CLICKED_ACTION_CARD_OPTION
  },
  CLICKED_ACTION_DETAILS_BUTTON: {
    eventProps: {
      action: 'clicked to show or hide action details'
    },
    eventType: TrackingEvents.CLICKED_ACTION_DETAILS_BUTTON
  },
  CLICKED_ACTION_IN_PANEL: {
    eventProps: {
      action: 'clicked action in panel'
    },
    eventType: TrackingEvents.CLICKED_ACTION_IN_PANEL
  },
  // For action panel redesign tracking
  CLICKED_APP_ACTION_IN_CONNECT_PANEL: {
    eventProps: {
      action: 'clicked on app action in connect an app panel'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ACTION_OUTPUT_ADDED: {
    eventProps: {
      action: 'interact with action outputs section',
      subAction: 'Clicked to add output'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ACTION_OUTPUT_DELETED: {
    eventProps: {
      action: 'interact with action outputs section',
      subAction: 'Clicked to remove output'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ACTION_OUTPUT_EDITED: {
    eventProps: {
      action: 'interact with action outputs section',
      subAction: 'Edited output name'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ACTION_OUTPUT_TYPE_EDITED: {
    eventProps: {
      action: 'interact with action outputs section',
      subAction: 'Edited output type'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  ACTION_OUTPUT_SAVED: {
    eventProps: {
      action: 'outputs fields were saved',
      subAction: 'Has user defined output fields'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_BACK_TO_WORKFLOWS: {
    eventProps: {
      action: 'clicked back to workflows'
    },
    eventType: TrackingEvents.CLICKED_BACK_TO_WORKFLOWS
  },
  CLICKED_CHANGE_TRIGGER_TYPE_BUTTON: {
    eventProps: {
      action: 'clicked to change the currently set up trigger type'
    },
    eventType: TrackingEvents.CLICKED_CHANGE_TRIGGER_TYPE_BUTTON
  },
  CLICKED_CHANGES_NAV_BUTTON: {
    eventProps: {
      action: 'clicked changes nav button in revision view'
    },
    eventType: TrackingEvents.INTERACTION
  },
  // For action panel redesign tracking
  CLICKED_CONNECT_AN_APP_BUTTON: {
    eventProps: {
      action: 'clicked connect an app button'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_CONNECT_FROM_MODAL: {
    eventProps: {
      action: 'clicked connect from modal'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_CONTACT_CALCULATION_LISTS_LINK: {
    eventProps: {
      action: 'clicked on link to create a list and redirect to lists ui'
    },
    eventType: TrackingEvents.CLICKED_CONTACT_CALCULATION_LISTS_LINK
  },
  CLICKED_COPY_ACTION: {
    eventProps: {
      action: 'copied an action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_CREATE_ACTION_SET: {
    eventProps: {
      action: 'clicked to create an action set'
    },
    eventType: TrackingEvents.CLICKED_CREATE_ACTION_SET
  },
  CLICKED_CREATE_WORKFLOW_DROPDOWN_TEMPLATE_LIBRARY_BUTTON: {
    eventProps: {
      action: 'clicked to navigate to the template library from the create workflow dropdown'
    },
    eventType: TrackingEvents.CLICKED_CREATE_WORKFLOW_DROPDOWN_TEMPLATE_LIBRARY_BUTTON
  },
  CLICKED_DELETE_ACTION_SET: {
    eventProps: {
      action: 'clicked to delete an action set'
    },
    eventType: TrackingEvents.CLICKED_DELETE_ACTION_SET
  },
  CLICKED_EDIT_ACTION_SET: {
    eventProps: {
      action: 'clicked to edit an action set'
    },
    eventType: TrackingEvents.CLICKED_EDIT_ACTION_SET
  },
  CLICKED_EDIT_WORKFLOW_BUTTON: {
    eventProps: {
      action: 'clicked on the edit/view workflow button'
    },
    eventType: TrackingEvents.CLICKED_EDIT_WORKFLOW_BUTTON
  },
  CLICKED_IGNORE_ALL_RISKS: {
    eventProps: {
      action: 'clicked to open ignore all risks modal'
    },
    eventType: TrackingEvents.CLICKED_IGNORE_ALL_RISKS
  },
  CLICKED_INSERT_ACTION_SET: {
    eventProps: {
      action: 'clicked to insert an action set'
    },
    eventType: TrackingEvents.CLICKED_INSERT_ACTION_SET
  },
  CLICKED_KB_ARTICLE_LINK: {
    eventProps: {
      action: 'clicked on knowledge base article in empty state from analyze tab'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_ANALYZE_TAB
  },
  CLICKED_LOAD_MORE_MARKETPLACE_APPS: {
    eventProps: {
      action: 'clicked to load more marketplace apps'
    },
    eventType: TrackingEvents.CLICKED_LOAD_MORE_MARKETPLACE_APPS
  },
  CLICKED_PAGE_SIMILAR_WORKFLOWS: {
    eventProps: {
      action: 'navigated between pages of similar workflows'
    },
    eventType: TrackingEvents.CLICKED_PAGE_SIMILAR_WORKFLOWS
  },
  CLICKED_PASTE_ACTION: {
    eventProps: {
      action: 'pasted an action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_RECENT_EXECUTION_ERRORS: {
    eventProps: {
      action: 'clicked recent execution errors link from canvas to action logs'
    },
    eventType: TrackingEvents.CLICKED_LINK_TO_ACTION_LOGS
  },
  CLICKED_REDO_WORKFLOW_BUTTON: {
    eventProps: {
      action: 'clicked redo workflow button on canvas'
    },
    eventType: TrackingEvents.CLICKED_REDO_WORKFLOW_BUTTON
  },
  CLICKED_RELAXED_VALIDATION_ALERTS_ROLLUP: {
    eventProps: {
      action: 'clicked to view the relaxed validation resolution panel from the alerts rollup'
    },
    eventType: TrackingEvents.CLICKED_RELAXED_VALIDATION_ALERTS_ROLLUP
  },
  CLICKED_RELAXED_VALIDATION_ERROR: {
    eventProps: {
      action: 'clicked a relaxed validation error within the resolution panel'
    },
    eventType: TrackingEvents.CLICKED_RELAXED_VALIDATION_ERROR
  },
  CLICKED_RELAXED_VALIDATION_RESOLUTION_PANEL_REVIEW_BUTTON: {
    eventProps: {
      action: 'clicked the review and publish button after resolving all validation errors'
    },
    eventType: TrackingEvents.CLICKED_RELAXED_VALIDATION_RESOLUTION_PANEL_REVIEW_BUTTON
  },
  CLICKED_RELAXED_VALIDATION_REVIEW_BUTTON: {
    eventProps: {
      action: 'clicked the relaxed validation review button'
    },
    eventType: TrackingEvents.CLICKED_RELAXED_VALIDATION_REVIEW_BUTTON
  },
  CLICKED_RESTORE_WORKFLOW: {
    eventProps: {
      action: 'clicked to attempt to restore a workflow'
    },
    eventType: TrackingEvents.CLICKED_RESTORE_WORKFLOW
  },
  CLICKED_SIMILAR_WORKFLOW_LINK: {
    eventProps: {
      action: 'clicked link to a similar workflow'
    },
    eventType: TrackingEvents.CLICKED_SIMILAR_WORKFLOW_LINK
  },
  CLICKED_TEMPLATE_ACCESS_INFO_PLAN_LINK: {
    eventProps: {
      action: 'clicked a template access info required plans link'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_ACCESS_INFO_PLAN_LINK
  },
  CLICKED_TEMPLATE_ACCESS_INFO_PRICING_LINK: {
    eventProps: {
      action: 'clicked a template access info pricing plans link'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_ACCESS_INFO_PRICING_LINK
  },
  CLICKED_TEMPLATE_LIBRARY_CTA_LINK: {
    eventProps: {
      action: 'clicked to navigate to the template library from the template library CTA link'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_LIBRARY_CTA_LINK
  },
  CLICKED_TEMPLATE_LIBRARY_FILTER: {
    eventProps: {
      action: 'clicked a template library filter'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_LIBRARY_FILTER
  },
  CLICKED_TEMPLATE_LIBRARY_HELP_CARD_LINK: {
    eventProps: {
      action: 'clicked a template library help card link'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_LIBRARY_HELP_CARD_LINK
  },
  CLICKED_TEMPLATE_ONBOARDING_TEMPLATE_LIBRARY_LINK: {
    eventProps: {
      action: 'clicked to navigate to the template library from the template onboarding link'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_ONBOARDING_TEMPLATE_LIBRARY_LINK
  },
  CLICKED_TEMPLATE_PREVIEW_LINK: {
    eventProps: {
      action: 'clicked to preview a template'
    },
    eventType: TrackingEvents.CLICKED_TEMPLATE_PREVIEW_LINK
  },
  CLICKED_TEMPLATES_LINK: {
    eventProps: {
      action: 'clicked on templates link from analyze tab'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_ANALYZE_TAB
  },
  CLICKED_THE_CONNECT_APP_PANEL: {
    eventProps: {
      action: 'clicked the connect app panel'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_TO_CONNECT_AN_APP: {
    eventProps: {
      action: 'clicked to connect an app'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLICKED_TO_VIEW_APP_IN_MARKETPLACE: {
    eventProps: {
      action: 'clicked to view app in marketplace'
    },
    eventType: TrackingEvents.CLICKED_MARKETPLACE_APP_LINK
  },
  CLICKED_TO_VIEW_MARKETPLACE_APP_DETAILS: {
    eventProps: {
      action: 'clicked to view marketplace app details'
    },
    eventType: TrackingEvents.CLICKED_MARKETPLACE_APP_LINK
  },
  CLICKED_UNDO_WORKFLOW_BUTTON: {
    eventProps: {
      action: 'clicked undo workflow button on canvas'
    },
    eventType: TrackingEvents.CLICKED_UNDO_WORKFLOW_BUTTON
  },
  CLICKED_VIEW_SIMILAR_WORKFLOWS: {
    eventProps: {
      action: 'opened similar workflows detail panel'
    },
    eventType: TrackingEvents.CLICKED_VIEW_SIMILAR_WORKFLOWS
  },
  CLICKED_VIEW_WORKFLOW_ISSUES: {
    eventProps: {
      action: 'clicked to view issues in issue management center'
    },
    eventType: TrackingEvents.CLICKED_VIEW_WORKFLOW_ISSUES
  },
  CLICKED_VIEW_WORKFLOW_REVISION: {
    eventProps: {
      action: 'clicked view workflow revision link in event details panel'
    },
    eventType: TrackingEvents.CLICKED_VIEW_WORKFLOW_REVISION
  },
  CLICKED_VIEWS_LINK: {
    eventProps: {
      action: 'clicked on link to go to a view from analyze tab'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_ANALYZE_TAB
  },
  CLICKED_WHY_DID_THIS_NOT_ENROLL: {
    eventProps: {
      action: 'clicked why did my object not enroll'
    },
    eventType: TrackingEvents.INTERACTED_WITH_NON_ENROLLMENT_DIAGNOSIS
  },
  CLICKED_WORKFLOW_NAME: {
    eventProps: {
      action: 'clicked on the workflow name link on the index page'
    },
    eventType: TrackingEvents.CLICKED_WORKFLOW_NAME
  },
  CLICKED_ZOOM_BUTTON: {
    eventProps: {
      action: 'clicked zoom button on canvas'
    },
    eventType: TrackingEvents.CLICKED_ZOOM_BUTTON
  },
  CLONE_WORKFLOW_CLICK: {
    eventProps: {
      action: 'clicked to clone workflow'
    },
    eventType: TrackingEvents.CREATE_WORKFLOW
  },
  CLONED_ACTION: {
    eventProps: {
      action: 'cloned an action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLONED_FILTER_BRANCH_ACTION: {
    eventProps: {
      action: 'cloned a filter branch'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CLONED_WORKFLOW: {
    eventProps: {
      action: 'cloned workflow'
    },
    eventType: TrackingEvents.CREATE_WORKFLOW
  },
  CLOSED_TRIGGER_SELECTION_ONBOARDING_TOUR: {
    eventProps: {
      action: 'closed trigger selection onboarding tour but did not complete it'
    },
    eventType: TrackingEvents.CLOSED_TRIGGER_SELECTION_ONBOARDING_TOUR
  },
  CLOSED_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 'closed workflow name and description modal'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  COMPLETED_RELAXED_VALIDATION_RESOLUTION_PANEL: {
    eventProps: {
      action: 'completed the relaxed validation resolution panel'
    },
    eventType: TrackingEvents.COMPLETED_RELAXED_VALIDATION_RESOLUTION_PANEL
  },
  COMPLETED_TRIGGER_SELECTION_ONBOARDING_TOUR: {
    eventProps: {
      action: 'completed the trigger selection onboarding tour'
    },
    eventType: TrackingEvents.COMPLETED_TRIGGER_SELECTION_ONBOARDING_TOUR
  },
  CONFIRM_IGNORE_ALL_RISKS: {
    eventProps: {
      action: 'clicked to ignore all risks for a workflow'
    },
    eventType: TrackingEvents.CONFIRM_IGNORE_ALL_RISKS
  },
  COPY_AI_EXAMPLE_PROMPT: {
    eventProps: {
      action: 'clicked to copy example AI prompt'
    },
    eventType: TrackingEvents.COPY_AI_EXAMPLE_PROMPT
  },
  COPY_DEAL_PROPERTY: {
    eventProps: {
      action: 'clicked to copy deal property to deal action'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  COPY_TICKET_PROPERTY: {
    eventProps: {
      action: 'clicked to copy ticket property to ticket action'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  CREATE_DEAL_ADD_LINE_ITEM: {
    eventProps: {
      action: 'interact with create deal action panel',
      subAction: 'Add a line item'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CREATE_DEAL_DELETE_LINE_ITEM: {
    eventProps: {
      action: 'interact with create deal action panel',
      subAction: 'Delete a line item'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CREATE_FOLDER: {
    eventProps: {
      action: 'created a new folder'
    },
    eventType: TrackingEvents.CREATE_FOLDER
  },
  CREATE_FOLDER_CLICK: {
    eventProps: {
      action: 'clicked to attempt to create a folder'
    },
    eventType: TrackingEvents.CREATE_FOLDER_CLICK
  },
  CREATED_WORKFLOW: {
    eventProps: {
      action: 'created workflow'
    },
    eventType: TrackingEvents.CREATED_WORKFLOW
  },
  CREATED_WORKFLOW_FROM_TEMPLATE: {
    eventProps: {
      action: 'clicked to create workflow from template'
    },
    eventType: TrackingEvents.CREATED_WORKFLOW_FROM_TEMPLATE
  },
  CUSTOM_CODE_ADDED_SECRET: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to add secret'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_CLICKED_TEST: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Opened the testing modal'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_DELETED_SECRET: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Deleted secret'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_EDIT_SECRET: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Edited secret'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_INPUT_ADDED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to add custom code input'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_INPUT_DELETED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to remove custom code input'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_INPUT_NAME_EDITED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Edited custom code input name'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_INPUT_PROPERTY_EDITED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Edited custom code input property'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_OPENED_TESTING: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked the testing section of the action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_OUTPUT_ADDED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to add custom code output'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_OUTPUT_DELETED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to remove custom code output'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_OUTPUT_NAME_EDITED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Edited custom code output name'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_OUTPUT_TYPE_EDITED: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Edited custom code output type'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_RAN_TEST: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Clicked to run the the test'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_SAVED_SECRET: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Saved secret'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_SELECTED_SECRET: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Selected secret'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_SELECTED_TESTABLE_OBJECT: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Selected an object to test with'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  CUSTOM_CODE_TYPED_IN_TEXT_BOX: {
    eventProps: {
      action: 'interact with custom code action panel',
      subAction: 'Typed in text box'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  DELAY_TOOLTIP_ACCEPTED: {
    eventProps: {
      action: 'used a tooltip suggestion to add a delay'
    },
    eventType: TrackingEvents.INTERACTION
  },
  DELAY_TOOLTIP_DISMISSED: {
    eventProps: {
      action: 'dismissed a tooltip suggestion to add a delay'
    },
    eventType: TrackingEvents.INTERACTION
  },
  DELETE_FOLDER: {
    eventProps: {
      action: 'deleted a folder'
    },
    eventType: TrackingEvents.DELETE_FOLDER
  },
  DELETE_FOLDER_AFTER_REFERENCE_CLICK: {
    eventProps: {
      action: 'delete a folder after references'
    },
    eventType: TrackingEvents.DELETE_FOLDER_AFTER_REFERENCE
  },
  DELETE_FOLDER_CLICK: {
    eventProps: {
      action: 'clicked to attempt to delete a folder'
    },
    eventType: TrackingEvents.DELETE_FOLDER_CLICK
  },
  DELETE_WORKFLOW_CLICK: {
    eventProps: {
      action: 'clicked to delete workflow'
    },
    eventType: TrackingEvents.DELETE_WORKFLOW_CLICK
  },
  DELETED_COMMENT: {
    eventProps: {
      action: 'deleted a comment'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  DELETED_EMAIL_FROM_EDITOR: {
    eventProps: {
      action: 'deleted email from inline editor'
    },
    eventType: TrackingEvents.DELETED_EMAIL_FROM_EDITOR
  },
  DELETED_FILTER_BRANCH_ACTION: {
    eventProps: {
      action: 'clicked to deleted a filter branch'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  DELETED_WORKFLOW: {
    eventProps: {
      action: 'deleted workflow'
    },
    eventType: TrackingEvents.DELETE_WORKFLOW
  },
  DISCARD_GENERATED_ASSET: {
    eventProps: {
      action: 'clicked to discard generated asset'
    },
    eventType: TrackingEvents.DISCARD_GENERATED_ASSET
  },
  DRAGGED_FILTER_BRANCH_ACTION: {
    eventProps: {
      action: 'reordered filter list with click and drag'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  EDIT_DATA_SOURCE_ACTION: {
    eventProps: {
      action: 'clicked to select a data source action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  EDIT_EVENT_TRIGGER: {
    eventProps: {
      action: 'event trigger edited'
    },
    eventType: TrackingEvents.EDIT_EVENT_TRIGGER
  },
  EDIT_REFINEMENT_CRITERIA: {
    eventProps: {
      action: 'edited refinement criteria'
    },
    eventType: TrackingEvents.EDIT_REFINEMENT_CRITERIA
  },
  EDITED_COLUMNS: {
    eventProps: {
      action: 'edited table columns'
    },
    eventType: TrackingEvents.INTERACTION
  },
  EDITED_COMMENT: {
    eventProps: {
      action: 'edited a comment'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  EMAIL_PERF_TIME_CHANGE: {
    eventProps: {
      action: 'changed email performance over time filter date range'
    },
    eventType: TrackingEvents.PERF_TIME_FILTER
  },
  EMBEDDED_APP_LOADED: {
    eventProps: {
      action: 'embedded app load time and success rate'
    },
    eventType: TrackingEvents.EMBEDDED_APP_LOADED
  },
  EMBEDDED_FLOW_CREATED: {
    eventProps: {
      action: 'created embedded workflow'
    },
    eventType: TrackingEvents.CREATED_EMBEDDED_WORKFLOW
  },
  ENROLL_EXISTING_CONTACTS: {
    eventProps: {
      action: 'changed setting to enroll existing contacts'
    },
    eventType: TrackingEvents.ENROLL_EXISTING_CONTACTS
  },
  ENROLL_EXISTING_CONTACTS_ACTIVATION: {
    eventProps: {
      action: 'changed setting to enroll existing contacts'
    },
    eventType: TrackingEvents.ENROLL_EXISTING_CONTACTS_ACTIVATION
  },
  ENROLL_TEST_CONTACT: {
    eventProps: {
      action: 'enrolled test contact'
    },
    eventType: TrackingEvents.TEST_WORKFLOW
  },
  ENROLL_TEST_OBJECT: {
    eventProps: {
      action: 'enrolled test object'
    },
    eventType: TrackingEvents.ENROLL_TEST_OBJECT
  },
  ENROLLMENT_GRAPH_BREAKDOWN_FILTER: {
    eventProps: {
      action: 'changed date breakdown of enrollment graph'
    },
    eventType: TrackingEvents.ENROLLMENT_GRAPH_BREAKDOWN_FILTER
  },
  EXPORT_WORKFLOW_TO_IMAGE: {
    eventProps: {
      action: 'clicked to export a workflow to an image'
    },
    eventType: TrackingEvents.MANAGE_WORKFLOWS
  },
  EXPORTED_WORKFLOWS: {
    eventProps: {
      action: 'exported workflows'
    },
    eventType: TrackingEvents.EXPORT_WORKFLOWS
  },
  FAILED_CONTACT_CALCULATION: {
    eventProps: {
      action: 'failed to calculate number of enrollable contacts'
    },
    eventType: TrackingEvents.CONTACT_CALCULATION
  },
  FIRST_NEW_WORKFLOW: {
    eventProps: {
      action: 'clicked to create workflow'
    },
    eventType: TrackingEvents.FIRST_NEW_WORKFLOW
  },
  GENERATE_DESCRIPTION_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 'generated description from workflow name and description modal'
    },
    eventType: TrackingEvents.GENERATE_WORKFLOW_DESCRIPTION
  },
  GENERATE_NAME_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 'generated name from workflow name and description modal'
    },
    eventType: TrackingEvents.GENERATE_WORKFLOW_NAME
  },
  HISTORY_FILTERS_ACTION_NAME: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed action name'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_ACTION_TYPE: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed action type'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_CLEAR_FILTERS: {
    eventProps: {
      action: 'used filters',
      subAction: 'cleared filters'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_DATE_RANGE: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed date range'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_ERROR_RECENCY: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed error recency'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_EVENT_TYPE: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed event type'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_RECORD: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed record'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_FILTERS_USER: {
    eventProps: {
      action: 'used filters',
      subAction: 'changed user'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_LOAD_MORE: {
    eventProps: {
      action: 'clicked to load more history data'
    },
    eventType: TrackingEvents.HISTORY_LOAD_MORE
  },
  HISTORY_REMOVE_RECENT_ERRORS_VIEW: {
    eventProps: {
      action: 'used filters',
      subAction: 'removed preset filters for recent errors'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  HISTORY_RETRY: {
    eventProps: {
      action: 'clicked Retry after history data failed to load'
    },
    eventType: TrackingEvents.RETRY_HISTORY
  },
  HOVERED_OVER_ANALYZE_TAB_GRAPH: {
    eventProps: {
      action: 'hovered over analyze tab graph'
    },
    eventType: TrackingEvents.HOVERED_OVER_ANALYZE_TAB_GRAPH
  },
  INSERT_GENERATED_ASSET: {
    eventProps: {
      action: 'clicked to insert generated asset'
    },
    eventType: TrackingEvents.INSERT_GENERATED_ASSET
  },
  INTERACT_WITH_CUSTOM_CODE_SECRETS: {
    eventProps: {
      action: 'interacted with custom code secrets'
    },
    eventType: TrackingEvents.INTERACT_WITH_CUSTOM_CODE_SECRETS
  },
  INTERACT_WITH_GO_TO_ACTION: {
    eventProps: {
      action: 'interacted with the go to action'
    },
    eventType: TrackingEvents.INTERACT_WITH_GO_TO_ACTION
  },
  INTERACT_WITH_SINGLE_ACTION_TESTING: {
    eventProps: {
      action: 'interaction with single action testing'
    },
    eventType: TrackingEvents.INTERACTION
  },
  INTERACTED_WITH_CREATE_OBJECT_ACTION: {
    eventProps: {
      action: 'clicked to edit the create object action'
    },
    eventType: TrackingEvents.INTERACTION
  },
  INTERACTED_WITH_EMAIL_EDITOR: {
    eventProps: {
      action: 'interacted with inline email editor'
    },
    eventType: TrackingEvents.INTERACTED_WITH_EMAIL_EDITOR
  },
  INTERACTED_WITH_QUICK_ADD_ACTION: {
    eventProps: {
      action: 'quick added an action'
    },
    eventType: TrackingEvents.INTERACTION
  },
  LINK_TO_ENROLLMENT_HISTORY: {
    eventProps: {
      action: 'clicked link to enrollment history tab from Top Metrics card'
    },
    eventType: TrackingEvents.CLICKED_LINK_TO_ENROLLMENT_HISTORY
  },
  LOAD_CONTACT_WORKFLOW_CONTAINER: {
    eventProps: {
      action: 'opened either the classic or platform workflow editing page for a given CONTACT workflow'
    },
    eventType: TrackingEvents.LOAD_CONTACT_WORKFLOW_CONTAINER
  },
  LOAD_INDEX_LISTING_PAGE: {
    eventProps: {
      action: 'loaded the index listing page of all workflows and folders, potentially empty if there are neither'
    },
    eventType: TrackingEvents.LOAD_INDEX_LISTING_PAGE
  },
  LOAD_PLATFORM_WORKFLOW_CONTAINER: {
    eventProps: {
      action: 'opened the platform workflow editing page'
    },
    eventType: TrackingEvents.LOAD_PLATFORM_WORKFLOW_CONTAINER
  },
  MANUALLY_ENROLL_INDIVIDUALS: {
    eventProps: {
      action: 'clicked to select contacts'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  MANUALLY_ENROLL_LISTS: {
    eventProps: {
      action: 'clicked to select lists'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  MANUALLY_ENROLLED_CONTACTS: {
    eventProps: {
      action: 'enrolled contacts manually'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  MOVE_WORKFLOW: {
    eventProps: {
      action: 'moved a workflow to a folder'
    },
    eventType: TrackingEvents.MOVE_WORKFLOW
  },
  MOVE_WORKFLOW_CLICK: {
    eventProps: {
      action: 'clicked to attempt to move workflow to a folder'
    },
    eventType: TrackingEvents.MOVE_WORKFLOW_CLICK
  },
  MOVED_ACTION: {
    eventProps: {
      action: 'moved an action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  NAVIGATE_TO_WORKFLOWS_APP_FROM_CONTEXTUAL_EMBED: {
    eventProps: {
      action: 'opened the full workflows app from the contextual embed'
    },
    eventType: TrackingEvents.NAVIGATE_TO_WORKFLOWS_APP_FROM_CONTEXTUAL_EMBED
  },
  // Remove once support for "Restore workflows" is finished (https://git.hubteam.com/HubSpot/AutomationTeam/issues/2806)
  NAVIGATED_OUTDATED_RESTORE_PAGE: {
    eventProps: {
      action: 'directly navigated to the outdated "Restore workflows" page'
    },
    eventType: TrackingEvents.NAVIGATED_OUTDATED_RESTORE_PAGE
  },
  NEW_WORKFLOW: {
    eventProps: {
      action: 'clicked to create workflow'
    },
    eventType: TrackingEvents.CREATE_WORKFLOW
  },
  ONBOARDING_TOUR: {
    eventProps: {
      action: 'completed or skipped an onboarding tour'
    },
    eventType: TrackingEvents.END_ONBOARDING_TOUR
  },
  OPEN_AI_PROMPT_EXAMPLES: {
    eventProps: {
      action: 'open AI prompt examples'
    },
    eventType: TrackingEvents.OPEN_AI_PROMPT_EXAMPLES
  },
  OPEN_MORE_DROPDOWN: {
    eventProps: {
      action: "Opened 'More' dropdown in the Editor navigation bar"
    },
    eventType: TrackingEvents.OPEN_MORE_DROPDOWN
  },
  OPEN_TABLE_ACTIONS_DROPDOWN: {
    eventProps: {
      action: 'opened table actions dropdown'
    },
    eventType: TrackingEvents.INTERACTION
  },
  OPEN_WORKFLOWS_APP_FROM_EMBED: {
    eventProps: {
      action: 'navigate to full workflows application from an embedded instance'
    },
    eventType: TrackingEvents.OPEN_WORKFLOWS_APP_FROM_EMBED
  },
  OPENED_ACTION_CONFIG: {
    eventProps: {
      action: 'clicked to edit action'
    },
    eventType: TrackingEvents.EDIT_ACTION_SPECIFIC
  },
  OPENED_CONNECTIONS_PANEL: {
    eventProps: {
      action: 'clicked to open workflow connections panel'
    },
    eventType: TrackingEvents.OPENED_CONNECTIONS_PANEL
  },
  OPENED_CREATE_ACTION_SET_MODAL: {
    eventProps: {
      action: 'clicked to open the create action set modal'
    },
    eventType: TrackingEvents.OPENED_CREATE_ACTION_SET_MODAL
  },
  OPENED_DIAGNOSE_BRANCH_PANEL: {
    eventProps: {
      action: 'opened diagnose branch panel'
    },
    eventType: TrackingEvents.OPENED_DIAGNOSE_BRANCH_PANEL
  },
  OPENED_DIAGNOSE_ENROLLMENT_PANEL: {
    eventProps: {
      action: 'opened enrollment diagnose panel'
    },
    eventType: TrackingEvents.OPENED_DIAGNOSE_ENROLLMENT_PANEL
  },
  OPENED_EDIT_REPORT_MODAL: {
    eventProps: {
      action: 'opened edit report modal'
    },
    eventType: TrackingEvents.OPENED_EDIT_REPORT_MODAL
  },
  OPENED_ENROLLMENT: {
    eventProps: {
      action: 'clicked to edit enrollment criteria'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  OPENED_ENROLLMENT_DETAILS_PANEL: {
    eventProps: {
      action: 'opened enrollment details panel'
    },
    eventType: TrackingEvents.OPENED_ENROLLMENT_DETAILS_PANEL
  },
  OPENED_EVENT_DETAILS_PANEL: {
    eventProps: {
      action: 'opened event details panel'
    },
    eventType: TrackingEvents.OPENED_EVENT_DETAILS_PANEL
  },
  OPENED_PLATFORM_ACTION_CONFIG: {
    eventProps: {
      action: 'clicked to edit action'
    },
    eventType: TrackingEvents.EDIT_PLATFORM_ACTION_SPECIFIC
  },
  OPENED_REVISIONS_PANEL: {
    eventProps: {
      action: 'opened revisions details panel'
    },
    eventType: TrackingEvents.OPENED_REVISIONS_PANEL
  },
  OPENED_TRIGGER_SELECTION_PANEL: {
    eventProps: {
      action: 'opened the trigger selection panel'
    },
    eventType: TrackingEvents.OPENED_TRIGGER_SELECTION_PANEL
  },
  OPENED_UNENROLLMENT: {
    eventProps: {
      action: 'clicked to edit unenrollment criteria',
      setting: 'unenrollment'
    },
    eventType: TrackingEvents.EDIT_SETTING
  },
  PERF_OPENED_EMAIL: {
    eventProps: {
      action: 'clicked to open email in email performance table'
    },
    eventType: TrackingEvents.EVALUATE_PERFORMANCE
  },
  PERF_TIME_CHANGE: {
    eventProps: {
      action: 'changed performance filter date range'
    },
    eventType: TrackingEvents.PERF_TIME_FILTER
  },
  PERFORMANCE_HISTORY_CHANGED_ENROLLMENT_SELECT: {
    eventProps: {
      action: 'changed the enrollment using the select field'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CHANGED_ENROLLMENT_SELECT
  },
  PERFORMANCE_HISTORY_CLICK_VIEW_IN_CRM_LINK: {
    eventProps: {
      action: 'clicked view in CRM link'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CLICK_VIEW_IN_CRM_LINK
  },
  PERFORMANCE_HISTORY_CLICK_WORKFLOW_NODE: {
    eventProps: {
      action: 'clicked a node on performance history workflow'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CLICK_WORKFLOW_NODE
  },
  PERFORMANCE_HISTORY_CLICKED_CHANGE_ENROLLMENT: {
    eventProps: {
      action: 'clicked the link to the enrollment history list screen'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CLICKED_CHANGE_ENROLLMENT
  },
  PERFORMANCE_HISTORY_CLICKED_VIEW_ENROLLMENT: {
    eventProps: {
      action: 'clicked the view enrollment button on performance history page'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CLICKED_VIEW_ENROLLMENT
  },
  PERFORMANCE_HISTORY_CLOSE_MODE_INDICATOR: {
    eventProps: {
      action: 'clicked close icon on performance history mode indicator'
    },
    eventType: TrackingEvents.CLOSE_MODE_INDICATOR
  },
  PERFORMANCE_HISTORY_FILTERS_ACTIONS: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed actions filter'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  PERFORMANCE_HISTORY_FILTERS_CLEAR: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'cleared filters'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CHANGE_FILTERS
  },
  PERFORMANCE_HISTORY_FILTERS_DATE_RANGE: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed date range'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  PERFORMANCE_HISTORY_FILTERS_DATE_RANGE_WITHIN_VERSIONS: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed date range within selected versions'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  PERFORMANCE_HISTORY_FILTERS_RECORD: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed record'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  PERFORMANCE_HISTORY_FILTERS_VERSIONS: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed workflow versions range'
    },
    eventType: TrackingEvents.CHANGE_HISTORY_FILTERS
  },
  PERFORMANCE_HISTORY_OPEN_ENROLLMENT_HISTORY_PAGE_FROM_DETAILS: {
    eventProps: {
      action: 'opened enrollment history page from the details page'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_OPEN_ENROLLMENT_HISTORY_PAGE_FROM_DETAILS
  },
  PERFORMANCE_HISTORY_REVISION_HISTORY: {
    eventProps: {
      action: 'clicked a link to go to revision history panel'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_PERFORMANCE_HISTORY
  },
  PERFORMANCE_HISTORY_TOGGLE_FILTER_BY_WORKFLOW_VERSIONS: {
    eventProps: {
      action: 'used filters on performance history page',
      subAction: 'changed filter by workflow versions checkbox'
    },
    eventType: TrackingEvents.PERFORMANCE_HISTORY_CHANGE_FILTERS
  },
  PERFORMANCE_HISTORY_TOGGLE_LOGEVENT_SECTION: {
    eventProps: {
      action: 'clicked to toggle log events section on performance history page'
    },
    eventType: TrackingEvents.TOGGLE_LOGEVENT_SECTION_PERFORMANCE_HISTORY
  },
  PERFORMANCE_HISTORY_TROUBLESHOOT_ENROLLMENT: {
    eventProps: {
      action: 'clicked a link to go to trouble shoot enrollment panel'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_PERFORMANCE_HISTORY
  },
  PERFORMANCE_HISTORY_VIEW_METRICS: {
    eventProps: {
      action: 'clicked view metrics link in the header'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_PERFORMANCE_HISTORY
  },
  PERFORMANCE_HISTORY_VIEW_SKIPPED_ENROLLMENTS: {
    eventProps: {
      action: 'clicked view skipped enrollments link'
    },
    eventType: TrackingEvents.CLICKED_LINK_ON_PERFORMANCE_HISTORY
  },
  RATE_DESCRIPTION_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 'rate generated description from workflow name and description modal'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  RATE_GENERATED_ASSET: {
    eventProps: {
      action: 'rated generated asset'
    },
    eventType: TrackingEvents.RATE_GENERATED_ASSET
  },
  REGENERATE_DESCRIPTION_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 're-generated description from workflow name and description modal'
    },
    eventType: TrackingEvents.GENERATE_WORKFLOW_DESCRIPTION
  },
  RELAXED_VALIDATION_ONBOARDING_COMPLETE: {
    eventProps: {
      action: 'clicked the cta button on the relaxed validation onboarding modal',
      tour: 'relaxed validation'
    },
    eventType: TrackingEvents.TOUR_COMPLETE
  },
  RELAXED_VALIDATION_ONBOARDING_SKIP: {
    eventProps: {
      action: 'dismissed the relaxed validation onboarding modal',
      tour: 'relaxed validation'
    },
    eventType: TrackingEvents.TOUR_SKIP
  },
  RELAXED_VALIDATION_ONBOARDING_START: {
    eventProps: {
      action: 'viewed the relaxed validation onboarding modal',
      tour: 'relaxed validation'
    },
    eventType: TrackingEvents.TOUR_START
  },
  RENAME_FOLDER: {
    eventProps: {
      action: 'renamed a folder'
    },
    eventType: TrackingEvents.RENAME_FOLDER
  },
  RENAME_FOLDER_CLICK: {
    eventProps: {
      action: 'clicked to rename a folder'
    },
    eventType: TrackingEvents.RENAME_FOLDER_CLICK
  },
  RENDER_LOG_EVENT: {
    eventProps: {
      action: 'rendered log event'
    },
    eventType: TrackingEvents.RENDER_LOG_EVENT
  },
  RENDERED_EMPTY_SEARCH_RESULTS_IN_PANEL: {
    eventProps: {
      action: 'empty search results in panel'
    },
    eventType: TrackingEvents.RENDERED_EMPTY_SEARCH_RESULTS_IN_PANEL
  },
  RENDERED_ILLUSTRATION_EMPTY_STATE: {
    eventProps: {
      action: 'rendered illustration empty state'
    },
    eventType: TrackingEvents.RENDERED_ILLUSTRATION_EMPTY_STATE
  },
  RENDERED_TEMPLATES_ONBOARDING: {
    eventProps: {
      action: 'rendered templates onboarding'
    },
    eventType: TrackingEvents.RENDERED_TEMPLATES_ONBOARDING
  },
  REORDERED_FILTER_BRANCH_ACTION: {
    eventProps: {
      action: 'reordered filter list with buttons'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  REQUEST_TEMPLATE_SUGGESTION: {
    eventProps: {
      action: 'requested template suggestions'
    },
    eventType: TrackingEvents.INTERACTION
  },
  REQUESTED_CONTACT_ESTIMATE: {
    eventProps: {
      action: 'requested enrollment estimate'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  RESTORED_WORKFLOW: {
    eventProps: {
      action: 'restored a workflow'
    },
    eventType: TrackingEvents.RESTORED_WORKFLOW
  },
  RETRY_EVENT_DETAILS: {
    eventProps: {
      action: 'clicked Retry after event details panel failed to load'
    },
    eventType: TrackingEvents.RETRY_EVENT_DETAILS
  },
  RETRY_FAILED_REFERENCES: {
    eventProps: {
      action: 'retry fetch on failed references api call'
    },
    eventType: TrackingEvents.RETRY_FAILED_REFERENCES
  },
  RETRY_RISK_DETAILS: {
    eventProps: {
      action: 'clicked Retry after risk details panel failed to load'
    },
    eventType: TrackingEvents.RETRY_RISK_DETAILS
  },
  REVIEW_WORKFLOW_INTERACTION: {
    eventProps: {
      action: 'review workflow interaction'
    },
    eventType: TrackingEvents.INTERACTION
  },
  RISKS_TABLE_CLEAR_FILTERS: {
    eventProps: {
      action: 'used risk table filters',
      subAction: 'clicked to clear filters'
    },
    eventType: TrackingEvents.RISKS_TABLE_FILTERS
  },
  RISKS_TABLE_COLUMN_SORT: {
    eventProps: {
      action: 'sorted risks table by a column'
    },
    eventType: TrackingEvents.RISKS_TABLE_COLUMN_SORT
  },
  RISKS_TABLE_FILTER_BY_STATUS: {
    eventProps: {
      action: 'used risk table filters',
      subAction: 'clicked to filter by risk status (current/ignored)'
    },
    eventType: TrackingEvents.RISKS_TABLE_FILTERS
  },
  SAVED_A_DATA_SOURCE_TO_WORKFLOW: {
    eventProps: {
      action: 'saved a data source to their workflow'
    },
    eventType: TrackingEvents.SAVED_A_DATA_SOURCE_TO_WORKFLOW
  },
  SAVED_A_NEW_SUGGESTED_ACTION: {
    eventProps: {
      action: 'clicked to save a new action generated by a suggestion'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  SAVED_ACTION: {
    eventProps: {
      action: 'saved action'
    },
    eventType: TrackingEvents.EDIT_ACTION_SPECIFIC
  },
  SAVED_AND_EXITED_ACTION_SET: {
    eventProps: {
      action: 'saved and exited the action set canvas'
    },
    eventType: TrackingEvents.SAVED_AND_EXITED_ACTION_SET
  },
  SAVED_BRANCH_ACTION: {
    eventProps: {
      action: 'saved a list branch action that with any number of branches and branch names'
    },
    eventType: TrackingEvents.SAVED_BRANCH_ACTION
  },
  SAVED_COMMENT: {
    eventProps: {
      action: 'saved a comment'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  SAVED_CONTEXTUAL_EMBED_ACTION: {
    eventProps: {
      action: 'saved an action in the contextual embed'
    },
    eventType: TrackingEvents.SAVED_CONTEXTUAL_EMBED_ACTION
  },
  SAVED_CREATE_OBJECT_ACTION: {
    eventProps: {
      action: 'saved create object action'
    },
    eventType: TrackingEvents.INTERACTION
  },
  SAVED_DESCRIPTION: {
    eventProps: {
      action: 'saved new description'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SAVED_EDIT_REPORT_MODAL: {
    eventProps: {
      action: 'saved edit report modal'
    },
    eventType: TrackingEvents.SAVED_EDIT_REPORT_MODAL
  },
  SAVED_EMAIL_FROM_EDITOR: {
    eventProps: {
      action: 'saved email from inline editor'
    },
    eventType: TrackingEvents.SAVED_EMAIL_FROM_EDITOR
  },
  SAVED_ENROLLMENT: {
    eventProps: {
      action: 'saved enrollment criteria'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  SAVED_ENROLLMENT_NOTIFICATION_SETTINGS: {
    eventProps: {
      action: 'saved enrollment notification settings'
    },
    eventType: TrackingEvents.EDIT_NOTIFICATION_SETTINGS
  },
  SAVED_ENROLLMENT_OF_EMBEDDED_FLOW: {
    eventProps: {
      action: 'saved enrollment criteria of an embedded flow'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT_OF_EMBEDDED_FLOW
  },
  SAVED_ENROLLMENT_WITH_ASSOCIATION_LABEL: {
    eventProps: {
      action: 'saved enrollment criteria that uses association labels'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  SAVED_EXECUTION_TIME: {
    eventProps: {
      action: 'saved execution time in settings'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SAVED_GOALS: {
    eventProps: {
      action: 'saved new goals'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SAVED_NEW_ACTION_SUGGESTED_BY_TOOLTIP: {
    eventProps: {
      action: 'clicked to save a new action generated by a tooltip on the canvas'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  SAVED_NEW_ACTION_WITH_SUGGESTIONS: {
    eventProps: {
      action: 'clicked to save a new action with available suggestions'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  SAVED_OPTIMIZATION: {
    eventProps: {
      action: 'saved flow optimization'
    },
    eventType: TrackingEvents.SAVED_OPTIMIZATION
  },
  SAVED_PLATFORM_ACTION: {
    eventProps: {
      action: 'saved action'
    },
    eventType: TrackingEvents.EDIT_PLATFORM_ACTION_SPECIFIC
  },
  SAVED_RELAXED_VALIDATION_ACTION: {
    eventProps: {
      action: 'saved an action with missing required fields'
    },
    eventType: TrackingEvents.SAVED_RELAXED_VALIDATION_ACTION
  },
  SAVED_SETTINGS: {
    eventProps: {
      action: 'saved settings'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SAVED_STATIC_BRANCH_ACTION: {
    eventProps: {
      action: 'saved the static branch action'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SAVED_TEMPLATE_ENROLLMENT_GUIDED_SETUP: {
    eventProps: {
      action: 'finished and saved the template enrollment guided setup'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  SAVED_UNENROLLMENT: {
    eventProps: {
      action: 'saved unenrollment criteria',
      setting: 'unenrollment'
    },
    eventType: TrackingEvents.EDIT_SETTING
  },
  SAVED_WORKFLOW_NAME_AND_DESCRIPTION_MODAL: {
    eventProps: {
      action: 'saved workflow name and description modal with changes'
    },
    eventType: TrackingEvents.EDIT_PROPERTIES
  },
  SEARCH_DATA_PANEL_PROPERTIES: {
    eventProps: {
      action: 'search data panel properties'
    },
    eventType: TrackingEvents.SEARCH_DATA_PANEL_PROPERTIES
  },
  SEARCHED_SIMILAR_WORKFLOWS: {
    eventProps: {
      action: 'searched for similar workflows'
    },
    eventType: TrackingEvents.SEARCHED_SIMILAR_WORKFLOWS
  },
  SEARCHED_WORKFLOW_TEMPLATES: {
    eventProps: {
      action: 'made a search querying for specific templates'
    },
    eventType: TrackingEvents.SEARCHED_WORKFLOW_TEMPLATES
  },
  SELECT_DATA_SOURCE_ACTION: {
    eventProps: {
      action: 'selected an action for a data source'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  SELECTED_MENU_BAR_OPTION: {
    eventProps: {
      action: 'selected menu bar option'
    },
    eventType: TrackingEvents.SELECTED_MENU_BAR_OPTION
  },
  SELECTED_PROPERTY_TRIGGER: {
    eventProps: {
      action: 'selected a property for a trigger'
    },
    eventType: TrackingEvents.SELECTED_PROPERTY_TRIGGER
  },
  SEND_EMAIL_PREVIEW: {
    eventProps: {
      action: 'sent email preview'
    },
    eventType: TrackingEvents.INTERACTION
  },
  SIMULATE_RECORD: {
    eventProps: {
      action: 'simulated enrolling a record in the workflow'
    },
    eventType: TrackingEvents.INTERACTION
  },
  SORTED_MARKETPLACE_APPS: {
    eventProps: {
      action: 'sorted marketplace apps'
    },
    eventType: TrackingEvents.SORTED_MARKETPLACE_APPS
  },
  SUCCESSFUL_CONTACT_CALCULATION: {
    eventProps: {
      action: 'sucesssfully calculated number of enrollable contacts'
    },
    eventType: TrackingEvents.CONTACT_CALCULATION
  },
  TEMPLATE_SUGGESTION_ERROR: {
    eventProps: {
      action: 'template suggestion error'
    },
    eventType: TrackingEvents.INTERACTION
  },
  TEST_CRITERIA: {
    eventProps: {
      action: 'clicked to test a contact against criteria'
    },
    eventType: TrackingEvents.EDIT_ENROLLMENT
  },
  TOGGLE_AT_RISK_WORKFLOWS_TAB_DESCRIPTION_BANNER: {
    eventProps: {
      action: 'clicked to toggle the At-risk workflows tab description banner'
    },
    eventType: TrackingEvents.TOGGLE_DESCRIPTION_BANNER
  },
  TOGGLE_ENROLLMENT_DETAILS_PANEL_SECTION: {
    eventProps: {
      action: 'clicked to toggle section(s) of the enrollment details panel'
    },
    eventType: TrackingEvents.TOGGLE_ENROLLMENT_DETAILS_PANEL_SECTION
  },
  TOGGLE_ENROLLMENT_TYPE: {
    eventProps: {
      action: 'changed enrollment type'
    },
    eventType: TrackingEvents.TOGGLE_ENROLLMENT_TYPE
  },
  TOGGLE_ERROR_LOG_SECTION: {
    eventProps: {
      action: 'clicked to toggle the Error log section of the Risk-details panel'
    },
    eventType: TrackingEvents.TOGGLE_ERROR_LOG_SECTION
  },
  TOGGLE_EVENT_TRIGGERS_BETA: {
    eventProps: {
      action: 'toggled event enrollment beta'
    },
    eventType: TrackingEvents.TOGGLE_EVENT_TRIGGERS_BETA
  },
  TOGGLE_INDEX_TAB_DESCRIPTION: {
    eventProps: {
      action: 'clicked to toggle description side panel on index page'
    },
    eventType: TrackingEvents.TOGGLE_DESCRIPTION_BANNER
  },
  TOGGLE_REENROLLMENT: {
    eventProps: {
      action: 'changed reenrollment enabled setting'
    },
    eventType: TrackingEvents.TOGGLE_REENROLLMENT
  },
  TOGGLE_REENROLLMENT_FILTER: {
    eventProps: {
      action: 'changed a reenrollment filter selection'
    },
    eventType: TrackingEvents.TOGGLE_REENROLLMENT_FILTER
  },
  TOGGLE_RISK_DETAILS_PANEL_DESCRIPTION_BANNER: {
    eventProps: {
      action: 'clicked to toggle the Risk-details panel description banner'
    },
    eventType: TrackingEvents.TOGGLE_DESCRIPTION_BANNER
  },
  TOGGLE_RISKS_TAB_DESCRIPTION_BANNER: {
    eventProps: {
      action: 'clicked to toggle the risks tab description banner'
    },
    eventType: TrackingEvents.TOGGLE_DESCRIPTION_BANNER
  },
  TOGGLED_APP_ACTION_CATEGORY_ACCORDION: {
    eventProps: {
      action: 'toggled app action category accordion'
    },
    eventType: TrackingEvents.TOGGLED_APP_ACTION_CATEGORY_ACCORDION
  },
  TOGGLED_OPERATIONS_HUB_ONBOARDING: {
    eventProps: {
      action: 'clicked to open or close the Operations Hub onboarding popover'
    },
    eventType: TrackingEvents.TOGGLED_OPERATIONS_HUB_ONBOARDING
  },
  TOOLTIP_DISABLED: {
    eventProps: {
      action: 'permanently dismissed a tooltip type'
    },
    eventType: TrackingEvents.INTERACTION
  },
  UNENROLL_MODAL: {
    eventProps: {
      action: 'clicked Unenroll button to open unenrollment modal'
    },
    eventType: TrackingEvents.UNENROLL_MODAL
  },
  UPDATED_SETTING: {
    eventProps: {
      action: 'updated a setting'
    },
    eventType: TrackingEvents.EDIT_SETTING
  },
  VIEW_DOC: {
    eventProps: {
      action: 'clicked documentation link'
    },
    eventType: TrackingEvents.VIEW_DOC
  },
  VIEW_EDITOR_WITH_ENROLLMENT_HISTORY_PANEL: {
    eventProps: {
      action: 'viewed the editor while ungated to the Enrollment history panel'
    },
    eventType: TrackingEvents.VIEW_EDITOR_WITH_ENROLLMENT_HISTORY_PANEL
  },
  VIEW_PAID_USER_SETTINGS: {
    eventProps: {
      action: 'clicked paid user settings link'
    },
    eventType: TrackingEvents.INTERACTION
  },
  VIEW_RISK_DETAILS_PANEL: {
    eventProps: {
      action: 'viewed the risk details panel'
    },
    eventType: TrackingEvents.VIEW_RISK_DETAILS_PANEL
  },
  VIEWED_ACTION_CONFIG_ALERT: {
    eventProps: {
      action: 'viewed an alert within the action config panel'
    },
    eventType: TrackingEvents.VIEWED_ACTION_CONFIG_ALERT
  },
  VIEWED_ADD_DATA_SOURCE: {
    eventProps: {
      action: 'viewed add data source panel'
    },
    eventType: TrackingEvents.VIEWED_ADD_DATA_SOURCE
  },
  VIEWED_AT_RISK_WORKFLOWS_TAB: {
    eventProps: {
      action: 'viewed the At-risk workflows tab'
    },
    eventType: TrackingEvents.VIEWED_AT_RISK_WORKFLOWS_TAB
  },
  VIEWED_DATA_PANEL_DATA_SOURCE: {
    eventProps: {
      action: 'viewed data panel data source'
    },
    eventType: TrackingEvents.VIEWED_DATA_PANEL_DATA_SOURCE
  },
  VIEWED_DATA_PASSING_PANEL: {
    eventProps: {
      action: 'viewed data passing panel'
    },
    eventType: TrackingEvents.VIEWED_DATA_PASSING_PANEL
  },
  VIEWED_FORMULA_PREVIEW_SAMPLE_DATA: {
    eventProps: {
      action: 'clicked to view/edit formula preview sample data'
    },
    eventType: TrackingEvents.VIEWED_FORMULA_PREVIEW_SAMPLE_DATA
  },
  VIEWED_OPERATIONS_HUB_ONBOARDING_PAGE: {
    eventProps: {
      action: 'clicked to view a subscreen in the Operations Hub onboarding popover'
    },
    eventType: TrackingEvents.VIEWED_OPERATIONS_HUB_ONBOARDING_PAGE
  },
  VIEWED_PROPERTY_TRIGGER_SELECTION_PANEL: {
    eventProps: {
      action: 'viewed the property trigger selection panel'
    },
    eventType: TrackingEvents.VIEWED_PROPERTY_TRIGGER_SELECTION_PANEL
  },
  VIEWED_REFERENCE_TYPE: {
    eventProps: {
      action: 'viewed a reference'
    },
    eventType: TrackingEvents.VIEWED_REFERENCE_TYPE
  },
  VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL: {
    eventProps: {
      action: 'viewed the relaxed validation resolution panel'
    },
    eventType: TrackingEvents.VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL
  },
  VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL_TEMPLATE_DESCRIPTION: {
    eventProps: {
      action: 'viewed the template description within the relaxed validation resolution panel'
    },
    eventType: TrackingEvents.VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL_TEMPLATE_DESCRIPTION
  },
  VIEWED_RISKS_TAB: {
    eventProps: {
      action: 'viewed the Risks index tab'
    },
    eventType: TrackingEvents.VIEWED_RISKS_TAB
  },
  VIEWED_SPECIFIC_ALERT: {
    eventProps: {
      action: 'clicked on alert in rollup'
    },
    eventType: TrackingEvents.VIEWED_SPECIFIC_ALERT
  },
  WEBHOOK_CLICKED_REQUEST_TAB: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Click to view request tab'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_CLICKED_RESPONSE_TAB: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Click to view response tab'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_CLICKED_TEST: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Clicked to run a test for the webhook'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_REMOVED_OUTPUT: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Click remove from the outputs table'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_SAVED: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Saved a webhook action'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_SELECTED_OUTPUT: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Selected an output from the response tree'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_SELECTED_TESTABLE_OBJECT: {
    eventProps: {
      action: 'interact with webhook action panel',
      subAction: 'Selected an object to test with'
    },
    eventType: TrackingEvents.EDIT_ACTIONS
  },
  WEBHOOK_TRIGGER_INTERACTION: {
    eventProps: {
      action: 'webhook wizard interaction'
    },
    eventType: TrackingEvents.WEBHOOK_TRIGGER_INTERACTION
  },
  WEBHOOK_TRIGGER_MODIFIED: {
    eventProps: {
      action: 'modified webhook trigger'
    },
    eventType: TrackingEvents.WEBHOOK_TRIGGER_INTERACTION
  },
  WEBHOOK_WIZARD_CLOSED: {
    eventProps: {
      action: 'webhook wizard closed'
    },
    eventType: TrackingEvents.WEBHOOK_TRIGGER_INTERACTION
  },
  WEBHOOK_WIZARD_STEP_CHANGE: {
    eventProps: {
      action: 'webhook wizard step changed'
    },
    eventType: TrackingEvents.WEBHOOK_TRIGGER_INTERACTION
  },
  WORKFLOW_SETTINGS_INTERACTION: {
    eventProps: {
      action: 'workflows settings interaction'
    },
    eventType: TrackingEvents.INTERACTION
  },
  WORKFLOWS_ACTION_TYPE_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed action type'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_AUTHOR_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed created by'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_PLATFORM_SOURCE_APPS_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed tool created from'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_RETRY_GET_FLOW_REVISION: {
    eventProps: {
      action: 'clicked to retry fetching flow revisions'
    },
    eventType: TrackingEvents.WORKFLOWS_RETRY_GET_FLOW_REVISION
  },
  WORKFLOWS_REVISION_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed revision'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_RISK_STATUS_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed risk status'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_SEARCH_BY_DESCRIPTION_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'toggled searching to include description'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_SEARCH_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'clicked on workflows search input box'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_STATUS_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed status'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_TABLE_COLUMN_SORT: {
    eventProps: {
      action: 'sorted workflows table by a column'
    },
    eventType: TrackingEvents.WORKFLOWS_TABLE_COLUMN_SORT
  },
  WORKFLOWS_TEAM_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed team'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_TYPE_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed type'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  WORKFLOWS_VIEW_FILTER: {
    eventProps: {
      action: 'changed workflows table filter',
      subAction: 'changed view'
    },
    eventType: TrackingEvents.WORKFLOWS_FILTER
  },
  CLICKED_ADD_DATASET_TRIGGER: {
    eventType: TrackingEvents.CLICKED_ADD_DATASET_TRIGGER,
    eventProps: {
      action: 'clicked to add a dataset trigger'
    }
  },
  SAVED_DATASET_TRIGGER: {
    eventType: TrackingEvents.SAVED_DATASET_TRIGGER,
    eventProps: {
      action: 'saved a dataset trigger'
    }
  },
  ACTIVATED_DATASET_WORKFLOW: {
    eventType: TrackingEvents.ACTIVATED_DATASET_WORKFLOW,
    eventProps: {
      action: 'saved a workflow with dataset triggers'
    }
  }
};
class TrackableEvent extends Record({
  eventType: '',
  eventProps: {}
}, 'TrackableEvent') {}
const Trackables = Object.fromEntries(Object.keys(TrackablesDictionary).map(key => [key, key]));
export const TrackableDefinitions = Object.keys(Trackables).reduce((acc, key) => acc.set(key, (extraArgs = {}) => new TrackableEvent(Object.assign({}, TrackablesDictionary[key], {
  eventProps: Object.assign({}, TrackablesDictionary[key].eventProps, extraArgs)
}))), ImmutableMap());
export default Trackables;